import autosize from "autosize";

const AutosizeTextareas = {
    init: () => {
        autosize(document.querySelectorAll("textarea[data-autosize]"));
    },
};

export { AutosizeTextareas };
